module.exports = __webpack_public_path__ + "img/b9fa1c9.png";